// Constants for different requests for current reducer
export default {
  schedule: 'SCHEDULE',
  createSchedule: 'CREATE_SCHEDULE',
  updateSchedule: 'UPDATE_SCHEDULE',
};
